export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["고객님은 ", _interpolate(_named("program")), "의 수거 거점 등록을 신청 중입니다"])}
    }
  })
}
